import { AlignCenter } from "lucide-react";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "49%",

      rows: {
        row1: [
          {
            name: "contactName",
            label: "Name",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "contactDepartment",
            label: "Department",
            component: "text-field",
          },
        ],
        row3: [
          {
            name: "isContactMobile",
            label: "Mob",
            component: "checkboxbox",
            sx: {
              alignItem: "center",
            },

            width: "50%",
          },

          {
            name: "contactMobile",
            component: "text-field",
            width: "80%",
            gap: false,
          },
        ],
        row4: [
          {
            name: "isSetasPrimary",
            label: "set as Primary",
            component: "checkboxbox",
            width: "30%",
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "46%",
      rows: {
        row1: [
          {
            name: "contactTitle",
            label: "Title/Designation",
            component: "text-field",
          },
        ],
        row2: [
          {
            name: "contactTelephone",
            label: "Telephone",
            component: "text-field",
          },
        ],
        row3: [
          {
            name: "isContactEmail",
            label: "Email Address",
            component: "checkboxbox",
            sx: {
              alignItem: "center",
            },
          },
          {
            name: "contactEmail",
            gap: false,
            component: "text-field",
            width: "55%",
          },
        ],
      },
    },
  ],
};
